__turbopack_context__.v({
  "active": "web2-assets-store-module__rT0k7a__active",
  "button": "web2-assets-store-module__rT0k7a__button",
  "buttonText": "web2-assets-store-module__rT0k7a__buttonText",
  "cartButton": "web2-assets-store-module__rT0k7a__cartButton",
  "categoryActive": "web2-assets-store-module__rT0k7a__categoryActive",
  "categoryButton": "web2-assets-store-module__rT0k7a__categoryButton",
  "divider": "web2-assets-store-module__rT0k7a__divider",
  "noImage": "web2-assets-store-module__rT0k7a__noImage",
  "pagination": "web2-assets-store-module__rT0k7a__pagination",
  "search": "web2-assets-store-module__rT0k7a__search",
  "selected": "web2-assets-store-module__rT0k7a__selected",
  "title": "web2-assets-store-module__rT0k7a__title",
  "topSection": "web2-assets-store-module__rT0k7a__topSection",
});
